module.exports = __webpack_public_path__ + "static/media/sign-in-alt.be2f6e28.svg";